import initDocumentToc from '../../../../resources/js/modules/_document-toc'

document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('.mtt-terms-conditions')

  if (!wrappers.length) {
    return
  }

  wrappers.forEach((wrapper) => {
    const categoryTriggers = wrapper.querySelectorAll('[data-category-trigger]')
    const categoryPanels = wrapper.querySelectorAll('[data-category-panel]')
    const versionSelects = wrapper.querySelectorAll('[data-version-select]')

    categoryTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const categoryId = trigger.getAttribute('data-category-trigger')

        if (!categoryId) {
          return
        }

        categoryTriggers.forEach((item) => {
          const isActive = item === trigger
          item.classList.toggle('active', isActive)
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false')
        })

        categoryPanels.forEach((panel) => {
          panel.classList.toggle('active', panel.getAttribute('data-category-panel') === categoryId)
        })

        window.dispatchEvent(new Event('scroll'))
      })
    })

    versionSelects.forEach((select) => {
      updateVersionState(wrapper, select)

      select.addEventListener('change', () => {
        updateVersionState(wrapper, select)
      })
    })
  })

  initDocumentToc()

  function updateVersionState (wrapper, select) {
    const categoryId = select.getAttribute('data-version-select')
    const versionId = select.value
    const categoryPanel = wrapper.querySelector('[data-category-panel="' + categoryId + '"]')

    if (!categoryPanel || !versionId) {
      return
    }

    const versions = categoryPanel.querySelectorAll('[data-version-panel]')
    const activeVersion = categoryPanel.querySelector('[data-version-panel="' + versionId + '"]')
    const latestLabel = categoryPanel.querySelector('[data-version-latest-label="' + categoryId + '"]')

    versions.forEach((version) => {
      version.classList.toggle('active', version.getAttribute('data-version-panel') === versionId)
    })

    if (latestLabel && activeVersion) {
      latestLabel.classList.toggle('is-hidden', activeVersion.getAttribute('data-is-latest') !== 'true')
    }

    window.dispatchEvent(new Event('scroll'))
  }

})
